import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CookieHandler from '../pages/LandingPage/Authentication/CookieHandler'

const UploadFileRequest = async (path,file, isAuthenticated) => {
  const formData = new FormData();
  formData.append('file', file);

  const apiUrl = process.env.REACT_APP_API_URL;
  console.log('API URL:', apiUrl);

  let headers = {
    'Content-Type': 'multipart/form-data'
  };

  if (isAuthenticated) {
    const token = CookieHandler.getCookie('token');
    headers['Authorization'] = `Bearer ${token}`;
  }

  try {
    const response = await axios.post(`${apiUrl}/api/${path}`, formData, { headers });
    if (response.status === 200) {
      toast.success('File uploaded and processed successfully.');
      return response.data;
    } else {
      toast.error('Server returned an error. Please try again later.');
    }
  } catch (error) {
    console.error('Error in uploadFile:', error);
    toast.error('A network or Server erro`/api/${path}`r occurred. Please try again later.');
  }
};

export default UploadFileRequest;
